import Sidebar from "../../components/SidebarNew/Sidebar";
import Navbar from "../../components/NavbarProfile/NavbarProfile";
import SupportLayout from "../../components/SupportLayout/SupportLayout";

import "./Support.css";

export default function Support() {
  const activeSide = 9;

  return (
    <>
      <div className="row gx-0 support_content">
        <Sidebar activeSide={activeSide} />
        <div className={`main col`}>
          <Navbar name={"Support"} />
          <SupportLayout />
        </div>
      </div>
    </>
  );
}
